<template>
  <div>
    <logged-in-header />
    <section class="section monitoring">
      <b-loading :is-full-page="true" :active="isLoading" :can-cancel="false" />
      <iframe
        v-if="openMartIframeSrc"
        width="100%"
        height="900"
        :src="openMartIframeSrc"
        frameborder="0"
        allow="camera; microphone; fullscreen; clipboard-read; clipboard-write"
        title="Carrinho Virtual - Portal do Lojista"
      ></iframe>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import loggedInHeader from "../components/common/LoggedInHeader";

export default {
  components: {
    loggedInHeader
  },

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["openMart", "merchantHasOpenMartCameraMonitoring"]),

    openMartIframeSrc() {
      if (
        !this.merchantHasOpenMartCameraMonitoring ||
        !this.openMart ||
        !this.openMart.status
      ) {
        return "";
      }

      const redirectUrl = this.normalizedOpenMartRedirectUrl(
        this.openMart.redirect_url
      );
      if (redirectUrl) {
        return redirectUrl;
      }

      const token = encodeURIComponent(this.openMart.token || "");
      if (!token) {
        return "";
      }
      return `https://portal.carrinhovirtual.com/sso?token=${token}`;
    }
  },

  methods: {
    getOpenMartIframeAuth() {
      this.isLoading = true;
      return this.$store
        .dispatch("getOpenMartIframeAuth")
        .catch(() => undefined)
        .finally(() => {
          this.isLoading = false;
        });
    },

    normalizedOpenMartRedirectUrl(redirectUrl) {
      if (!redirectUrl) {
        return "";
      }

      const url = redirectUrl.startsWith("http")
        ? redirectUrl
        : `https://${redirectUrl}`;

      try {
        const parsedUrl = new URL(url);
        return parsedUrl.hostname === "portal.carrinhovirtual.com" &&
          parsedUrl.pathname === "/sso"
          ? parsedUrl.href
          : "";
      } catch (e) {
        return "";
      }
    }
  },

  mounted() {
    this.getOpenMartIframeAuth();
  }
};
</script>

<style scoped>
.monitoring {
  min-height: 100vh;
  padding: 3.25rem 0 0;
  background-color: hsl(0, 0%, 96%);
}
</style>
